let vibe_cake_masters_add_to_cart_dropdown_module = ( function ( $ ) {

	let loading    = require( './loading' ),
		anim_speed = 400;

	let _init = function() {
		_attach_handlers();

		$( 'body' ).on( 'masters-cart_update_buttons', ( e ) => {
			_attach_handlers();
		} );
	};

	let _attach_handlers = function() {
		_detach_handlers();

		let $wrap = $( '.module-product-select' );

		if ( $wrap.length > 0 ) {
			$wrap.find( '.options-toggle' ).on( 'click', _toggle_dropdown );
			$wrap.find( 'input[type="radio"]' ).on( 'change', _change_selection );
		}
	};

	let _detach_handlers = function() {
		let $wrap = $( '.module-product-select' );

		if ( $wrap.length > 0 ) {
			$wrap.find( '.options-toggle' ).off( 'click', _toggle_dropdown );
			$wrap.find( 'input[type="radio"]' ).off( 'change', _change_selection );
		}
	};

	let _change_selection = function( e ) {
		let $label = $( this ).next( 'label' );

		$( this ).closest( '.module-product-select' ).find( '.options-toggle' ).html(
			'<span class="option-tier-name">' + $label.find( '.tier-name' ).html() + '</span> - ' + $label.find( '.tier-price' ).html()
		);

		let $form = $( this ).closest( '.module-add-to-cart-form' ),
			tier  = $form.find( 'input.module-tier:checked' ).val(),
			$card = $form.closest('.buy-module-card' )

		$card.loading();

		let data = {
			nonce: VibeCakeMastersScriptData.vibe_cake_masters_module_product_select_change_nonce,
			action: 'vibe_cake_masters_module_product_select_change',
			module: $form.data( 'module' ),
			tier: tier
		};

		$.post( VibeCakeMastersScriptData.ajaxurl, data, (response) => {
			_close_dropdown( $form.find( '.options' ) );

			if ( response.success ) {
				setTimeout( () => {
					$form.replaceWith( response.html );
					$card.loaded();

					$( 'body' ).trigger( 'masters-cart_update_buttons' );
				}, anim_speed );
			} else {
				$card.loaded();
			}
		});
	};

	let _toggle_dropdown = function( e ) {
		e.preventDefault();
		let $dropdown = $( this ).next( '.options' );

		if ( $dropdown.hasClass( 'open' ) ) {
			$( this ).addClass( 'closed' ).removeClass( 'open' );
			_close_dropdown( $dropdown );
		} else {
			$( this ).addClass( 'open' ).removeClass( 'closed' );
			_open_dropdown( $dropdown );
		}
	};

	let _open_dropdown = function( $dropdown ) {
		if ( $dropdown.hasClass( 'animating' ) ) {
			return;
		}

		$dropdown.addClass( 'animating' );
		$dropdown.removeClass( 'closed' );
		$dropdown.addClass( 'open' );
		$dropdown.slideDown( anim_speed );

		setTimeout( () => {
			$dropdown.removeClass( 'animating' );
		}, anim_speed );
	};

	let _close_dropdown = function( $dropdown ) {
		if ( $dropdown.hasClass( 'animating' ) ) {
			return;
		}

		$dropdown.addClass( 'animating' );
		$dropdown.removeClass( 'open' );
		$dropdown.addClass( 'closed' );
		$dropdown.slideUp( anim_speed );

		setTimeout( () => {
			$dropdown.removeClass( 'animating' );
		}, anim_speed );
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = vibe_cake_masters_add_to_cart_dropdown_module;